import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ShowBookingResponseV4Schema } from "../schema/ShowBookingResponseV4";

// Tipe untuk argumen hook
interface UseShowBookingV4Props {
    bookingId: string;
    // Parameter 'include' dibuat dinamis
    include?: string;
    enabled?: boolean;
}

export const useShowBookingV4 = ({ bookingId, include, enabled = true }: UseShowBookingV4Props) => {
    return useQuery({
        // queryKey dibuat unik dengan menyertakan bookingId dan include
        queryKey: ['booking', bookingId, { include }],

        queryFn: async () => {
            try {
                const response = await privateApi.get(`/v4/booking/${bookingId}`, {
                    params: {
                        // 'include' hanya akan ditambahkan jika ada nilainya
                        ...(include && { include }),
                    }
                });

                // Validasi respons API dengan skema Zod
                const validationResult = ShowBookingResponseV4Schema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("API Response Validation Failed:", validationResult.error.errors);
                    throw new Error("Invalid data format received from the server.");
                }

                return validationResult.data;

            } catch (error) {
                console.error(`Failed to fetch booking with ID ${bookingId}`, error);
                throw error;
            }
        },
        // Query hanya akan berjalan jika bookingId ada
        enabled: enabled && !!bookingId,
        retry: 1, // Hanya coba lagi 1 kali untuk permintaan 'show'
        refetchOnWindowFocus: false, // Tidak perlu refetch saat window fokus
    });
};